var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header"},[_c('h4',[_vm._v(_vm._s(_vm.$t(_vm.title)))])]),_c('v-data-table',{staticStyle:{"width":"100%"},attrs:{"headers":_vm.headers,"items":_vm.reports,"items-per-page":5,"footer-props":{
                showFirstLastPage: true,
                firstIcon: 'mdi-skip-backward',
                lastIcon: 'mdi-skip-forward',
        }},scopedSlots:_vm._u([{key:"item.StartDate",fn:function(ref){
        var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm.$services.format.formatDate(item.StartDate)))])]}},{key:"item.EndDate",fn:function(ref){
        var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm.$services.format.formatDate(item.EndDate)))])]}},{key:"item.DueDate",fn:function(ref){
        var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm.$services.format.formatDate(item.DueDate)))])]}},{key:"item.Status",fn:function(ref){
        var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm.$t(item.ScheduleStatus) || _vm.$t(item.Status)))])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }